import { type Routes } from '@angular/router';

import { adminGuard, adminPublicGuard } from '@core/auth/admin.guard';
import { LoginComponent } from '@features/login/login.component';
import { AppShellComponent } from '@features/layout/app-shell.component';
import { AuthCallbackComponent } from '@features/auth-callback/auth-callback.component';

export const routes: Routes = [
  // adminPublicGuard: redirects authenticated admins to /customers immediately.
  // Non-admin tokens (customers who try the admin login URL) are NOT auto-redirected
  // into the admin shell — they see the login form so they can provide admin credentials.
  { path: 'login', component: LoginComponent, canActivate: [adminPublicGuard] },
  // OIDC callback route — NO guard (must be reachable without being authenticated, Pitfall 8)
  { path: 'auth/callback', component: AuthCallbackComponent },
  {
    path: '',
    component: AppShellComponent,
    canActivate: [adminGuard],
    children: [
      {
        path: 'customers',
        loadComponent: () =>
          import('@features/customers/customers.component').then(
            (m) => m.CustomersComponent
          ),
      },
      {
        path: 'audit-log',
        loadComponent: () =>
          import('@features/audit-log/audit-log.component').then(
            (m) => m.AuditLogComponent
          ),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('@features/notifications/notifications.component').then(
            (m) => m.NotificationsComponent
          ),
      },
      {
        path: 'requests',
        loadComponent: () =>
          import('@features/requests/requests.component').then(
            (m) => m.RequestsComponent
          ),
      },
      {
        path: 'invoice-upload',
        loadComponent: () =>
          import('@features/invoice-upload/invoice-upload.component').then(
            (m) => m.InvoiceUploadComponent
          ),
      },
      {
        path: 'invoices',
        loadComponent: () =>
          import('@features/invoices/invoice-admin-list.component').then(
            (m) => m.InvoiceAdminListComponent
          ),
      },
      {
        path: 'billing',
        loadComponent: () =>
          import('@features/billing/billing-runs-list.component').then(
            (m) => m.BillingRunsListComponent
          ),
      },
      {
        path: 'billing/runs/:id',
        loadComponent: () =>
          import('@features/billing/billing-run-detail.component').then(
            (m) => m.BillingRunDetailComponent
          ),
      },
      {
        path: 'billing/imports',
        loadComponent: () =>
          import('@features/billing/billing-imports.component').then(
            (m) => m.BillingImportsComponent
          ),
      },
      {
        path: 'billing/reminders',
        loadComponent: () =>
          import('@features/billing/billing-reminders.component').then(
            (m) => m.BillingRemindersComponent
          ),
      },
      { path: '', redirectTo: 'customers', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
